import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoadUser_user } from "../__generated__/LoadUser";

// Define a type for the slice state
interface GlobalState {
  loading: boolean;
  projectId: number;
  user: LoadUser_user | null;
  focusLocked: boolean;
}

// Define the initial state using that type
const initialState: GlobalState = {
  loading: true,
  projectId: -1,
  user: null,
  focusLocked: false
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setUser: (state, action: PayloadAction<LoadUser_user>) => {
      state.user = action.payload;
    },
    setProjectId: (state, action: PayloadAction<number>) => {
      state.projectId = action.payload;
    },
    setFocusLocked: (state, action: PayloadAction<boolean>) => {
      state.focusLocked = action.payload;
    }
  },
});

export const { setLoading, setUser, setProjectId, setFocusLocked } =
  globalSlice.actions;

export default globalSlice.reducer;
